// tslint:disable
import { call, SsoResponse, SsoRequest } from 'services/api-service'

/**
 * Complete action in 'ssoRegDone' js callback by partner site after sso
 *
 * @method
 * @name ApiService#completeSsoAction
 * @param {string} sku -
 * @param {SsoRequest} body -
 */
function completeSsoAction(
  parameters: {
    sku: string
  },
  body: SsoRequest
): Promise<SsoResponse> {
  return call<SsoResponse>('POST', '/{siteKey}/user/sso', parameters, ['sku'], ['sku'], [], body)
}

export default { completeSsoAction }
